import React from 'react';
import PropTypes from 'prop-types';
import { getPerformanceLevelLabel } from '../../../../../utils/shared/trcUtils';
import { NA } from '../../../../../constants/shared/CommonConstants';

const Accuracy = ({
    accuracy,
    selfCorrectionsRate,
    performanceLevel,
    errorsRate,
    displayAccuracy,
}) => (
    <div className="legend">
        <p>
            <span className="label">Accuracy Rate:</span>
            {displayAccuracy ? `${accuracy}%, ${getPerformanceLevelLabel(performanceLevel)}` : NA}
        </p>
        {displayAccuracy && (
            <>
                <p>
                    <span className="label">SC Rate:</span>
                    {selfCorrectionsRate ? `1:${selfCorrectionsRate}` : 0}
                </p>
                <p>
                    <span className="label">Error Rate:</span>
                    {errorsRate ? `1:${errorsRate}` : 0}
                </p>
            </>
        )}
    </div>
);

Accuracy.defaultProps = {
    accuracy: null,
    selfCorrectionsRate: null,
    performanceLevel: null,
    errorsRate: null,
    displayAccuracy: false,
};

Accuracy.propTypes = {
    accuracy: PropTypes.number,
    selfCorrectionsRate: PropTypes.number,
    performanceLevel: PropTypes.string,
    errorsRate: PropTypes.number,
    displayAccuracy: PropTypes.bool,
};

export default Accuracy;
